import React from "react";
import _ from "lodash";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import {withEuroOrDash} from "../../../../../../../utils/utils";
import {ASSET_MODAL_TYPE_NEW, ASSETS_LIABILITIES_CONFIG, CONSTRUCTION_LOAN_CONTRACT_ID} from "../../../../../constants";
import {BcaDeleteIconButton} from "../../../../../../../components/Buttons/BcaIconButton/BcaIconButton";
import ExpireBadge from "../../../../../List/components/AssetCard/components/ExpireBadge";
import FutureBadge from "../../../../../List/components/AssetCard/components/FutureBadge";
import {PAYMENT_FREQUENCY} from "../../../../../AssetForm/components/ImmobilienForm";

import styles from "./styles";

const LinkedItem = ({classes, item, objectType, deleteLink, mainItemTypeId}) => (
  <Grid container spacing={2} alignItems={"center"}>
    <Grid item xs={true}>
      <Grid container>
        <Grid item xs={12} className={classes.typeLabel}>
          <b>{ASSETS_LIABILITIES_CONFIG[objectType].linkItemLabel}</b>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item className={classes.subCategoryName}><b>{item.sub_category_display}</b></Grid>
            {!!item.is_expired && <ExpireBadge expiredAt={item.expiration_date} />}
            {!!item.is_future && <FutureBadge />}
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.assetName}>{item.name}</Grid>
      </Grid>
    </Grid>
    <Grid item xs={'auto'} className={classes[ASSETS_LIABILITIES_CONFIG[objectType].linkItemValueColor]}>
      <LinkValueData linkedItem={item} mainItemTypeId={mainItemTypeId} />
    </Grid>
    {!!deleteLink && (
      <Grid item xs={'auto'}>
        <BcaDeleteIconButton
          onClick={() => deleteLink(item)}
          color={'secondary'}
        />
      </Grid>
    )}
  </Grid>
);

export default withStyles(styles)(LinkedItem);

const REAL_ESTATE_LINK_EXTRA = (item) => {
  const numberOfMonths = {
    [PAYMENT_FREQUENCY.monthly.value]: 1,
    [PAYMENT_FREQUENCY.quarterly.value]: 3,
    [PAYMENT_FREQUENCY.half_yearly.value]: 6,
    [PAYMENT_FREQUENCY.yearly.value]: 12,
  }[item.payment_frequency];

  return {
    title: 'Monatl. Nettoeinkommen',
    value: (item.net_income / numberOfMonths) || undefined
  }
}

const LINKS_RELATIONS_EXTRA = {
  [ASSET_MODAL_TYPE_NEW.IMMOBILIEN]: {
    [ASSET_MODAL_TYPE_NEW.LOAN]: (item) => ({
      title: 'Monatl. Annuität',
      value: item.monthly_annuity,
    }),
    [CONSTRUCTION_LOAN_CONTRACT_ID]: (item) => ({
      title: 'Monatl. Annuität',
      value: item.contributionAmount,
    })
  },
  [ASSET_MODAL_TYPE_NEW.LOAN]: {
    [ASSET_MODAL_TYPE_NEW.IMMOBILIEN]: REAL_ESTATE_LINK_EXTRA
  },
  [CONSTRUCTION_LOAN_CONTRACT_ID]: {
    [ASSET_MODAL_TYPE_NEW.IMMOBILIEN]: REAL_ESTATE_LINK_EXTRA
  }
};

const getExtraValueData = (mainItemTypeId, linkedItem) => {
  const fn = _.get(LINKS_RELATIONS_EXTRA, [mainItemTypeId, linkedItem.type_id]);

  return _.isFunction(fn) ? fn(linkedItem) : undefined;
};

const LinkValueData = ({linkedItem, mainItemTypeId}) => {
  const assetValueComponent = <b>{withEuroOrDash(linkedItem.asset_value)}</b>;

  const fieldData = getExtraValueData(mainItemTypeId, linkedItem);
  if(!fieldData || _.isNil(fieldData.value)) {
    return assetValueComponent;
  }

  return (
    <Grid container spacing={2} style={{textAlign: "right"}}>
      <Grid item>
        <div><b>Gesamtwert:</b></div>
        <div>{fieldData.title}:</div>
      </Grid>
      <Grid item>
        <div>{assetValueComponent}</div>
        <div>{withEuroOrDash(fieldData.value)}</div>
      </Grid>
    </Grid>
  )
};